import React, {useContext, useEffect} from 'react';
import Navbar from './components/Navbar';
import {createStyles, Theme, Container, CssBaseline} from '@material-ui/core';
import { Switch, Route, withRouter } from 'react-router-dom';
import routes from './router';
import './App.css';
import {makeStyles} from "@material-ui/core/styles";
import MyCssBaseline from "./components/CssBaseline";
import setup from "./plugins/axios";
import {AuthData, AuthHeaders} from "./models/auth";
import {getAuthData, setAuthData} from "./utils/auth";
import AuthService from './service/auth';
import {ProfileContext} from "./context/profile/profileContext";
import {getProfileData, setProfileData} from "./utils/profile";
import {useTranslation} from "react-i18next";
const drawerWidth = 240;
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: 0
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: drawerWidth - 150,
    },
  })
)

// @ts-ignore
const App: React.FC = ({history}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const {setProfile} = useContext(ProfileContext)
  useEffect(() => {
    beforeEach(history.location.pathname)
    // eslint-disable-next-line
  },[])
  const beforeEach = (pathname: string) => {
    let checkData:AuthHeaders | null = getAuthData()
    let profileData = getProfileData()
    setProfile(profileData)
    let route = routes.find(route => route.path.replace(':id', pathname.split('/')[2]) === pathname)
    if(typeof route === 'undefined'){
      history.push('/not_found')
      document.title = t('Not found')
    } else {
      document.title = t(route.title)
      if(pathname !== '/sign_up' ) {
        if(!checkData ) {
          getToken()
        }
      }
      else {
        if(checkData) {
          history.push('/')
        }
      }
    }
  }

  const getToken = async () => {
    const respData: AuthData = await AuthService.auth()

    if (respData.headers && respData.data) {
      if(respData.data.attributes.free_playback) {
        setAuthData(respData.headers);
        setProfileData(respData.data);
        setProfile(respData.data)
      } else {
        console.log('Access not allowed')
        // alert.show('Access not allowed', 'danger')
      }
    }
  }
  // MEMO: interceptors setup here
  setup(history)
  return (
    <>
      <CssBaseline />
      <MyCssBaseline />
      <Container >
        <Navbar/>
        <Switch>
          <main className={classes.content}>
            <div className={classes.drawerHeader} />
              <>
                { routes.map((route, index) => (
                  <Route
                    key={index}
                    exact={route.mode === 'exact'}
                    strict={route.mode === 'strict'}
                    sensitive={route.mode === 'sensitive'}
                    path={route.path}
                    render={routeProps => <route.component {...routeProps} title={route.title} />}
                  />
                ) )}
              </>
          </main>
        </Switch>
      </Container>
    </>
  );
}

export default withRouter(App);
